import $ from "jquery";
import Glide from "@glidejs/glide";
import AOS from "aos";
import Siema from "siema";
import Glightbox from 'glightbox';
$(document).ready(function () {
    AOS.init({
        disable: 'mobile'
    });
    if ($(".page-template-tpl-epicedudragon").length) {
        var lightbox = Glightbox({
            selector: 'a[href*="eepurl"]',
            width: "90vw",
            height: "80vh"
        });
    }
    setTimeout(function () { AOS.refresh(); }, 500);
    if ($('.carouselWrapper').length) {
        $('.carouselWrapper').each(function (k, e) {
            var customActiveClass = $(e).attr("data-custom-class") !== void 0 ? true : false;
            var gap = $(e).attr("data-gap") !== void 0 ? $(e).attr("data-gap") : 50;
            var view = $(e).attr("data-view") !== void 0 ? $(e).attr("data-view") : 2.5;
            var type = $(e).attr("data-type") !== void 0 ? $(e).attr("data-type") : "slider";
            var focus = $(e).attr("data-focus") !== void 0 ? $(e).attr("data-focus") : 0;
            var bound = $(e).attr("data-bound") !== void 0 ? $(e).attr("data-bound") : false;
            var autoplay = $(e).attr("data-autoplay") !== void 0 ? $(e).attr("data-autoplay") : false;
            var mobileGap = $(e).attr("data-mobile-gap") !== void 0 ? $(e).attr("data-mobile-gap") : 20;
            var mobileView = $(e).attr("data-mobile-view") !== void 0 ? $(e).attr("data-mobile-view") : 1;
            var mdGap = $(e).attr("data-md-gap") !== void 0 ? $(e).attr("data-md-gap") : gap;
            var mdView = $(e).attr("data-md-view") !== void 0 ? $(e).attr("data-md-view") : view;
            var smGap = $(e).attr("data-sm-gap") !== void 0 ? $(e).attr("data-sm-gap") : mdGap;
            var smView = $(e).attr("data-sm-view") !== void 0 ? $(e).attr("data-sm-view") : mdView;
            var glide = new Glide(e, {
                type: type,
                focusAt: focus,
                perView: view,
                gap: gap,
                startAt: 0,
                // bound: bound,
                bound: true,
                autoplay: autoplay,
                breakpoints: {
                    1050: {
                        gap: mdGap,
                        perView: mdView
                    },
                    768: {
                        gap: smGap,
                        perView: smView
                    },
                    600: {
                        focusAt: "center",
                        gap: mobileGap,
                        perView: mobileView
                    }
                }
            });
            glide.mount();
        });
    }
    $('.sliderWrapper').each(function (k, v) {
        var siema = $(v).find(".siema").get(0);
        var interval;
        var navigation = $(v).find(".navigation");
        var slider = new Siema({
            selector: siema,
            duration: 300,
            easing: 'ease-out',
            perPage: 1,
            startIndex: 0,
            draggable: true,
            multipleDrag: false,
            threshold: 20,
            loop: true,
            rtl: false,
            onInit: function () {
                navigation.find("span:eq(0)").addClass("current");
            },
            onChange: function () {
                clearInterval(interval);
                interval = setInterval(function () { return slider.next(); }, 5000);
                navigation.find(".current").removeClass("current");
                navigation.find("span:eq(" + slider.currentSlide + ")").addClass("current");
            }
        });
        interval = setInterval(function () { return slider.next(); }, 5000);
        navigation.on("click", "span", function (e) {
            e.preventDefault();
            slider.goTo($(e.currentTarget).index());
        });
    });
});
